import { createRoutine } from '../common/utils/routines';
import { NAME } from './constants';

export const setDefaultLocale = createRoutine(`${NAME}/SET_DEFAULT_LOCALE`);
export const addLocale = createRoutine(`${NAME}/ADD_LOCALE`);
export const removeLocale = createRoutine(`${NAME}/REMOVE_LOCALE`);
